import type { InsightsApi } from '@insights/insights-data-provider';

/**
 * Used for setting the instance of InsightsApi, so that components
 * with automatic analytics can access it, and send events through it.
 */
export default class AnalyticsManager {
	private static insightsApi: InsightsApi | null = null;

	/**
	 * Returns the set insightsApi instance, or null if it wasn't set.
	 */
	public static getInsightsApi(): InsightsApi | null {
		return this.insightsApi;
	}

	/**
	 * Planners should call this method as early as possible, before rendering
	 * any components which have automatic analytics enabled.
	 *
	 * @param insightsApi The insightsApi instance created by the planner.
	 */
	public static setInsightsApi(insightsApi: InsightsApi): void {
		this.insightsApi = insightsApi;
	}
}
